import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import BottomNav from '@/components/layout/BottomNav'
import Sidebar from '@/components/layout/Sidebar'
import Topbar from '@/components/layout/Topbar'
import { useAppAuth } from '@/contexts/AuthContext'

const titles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/perfil': 'Meu Perfil',
  '/protocolos': 'Requerimentos',
  '/protocolos/excluidos': 'Requerimentos Excluídos',
  '/sublocais': 'Sub Locais',
  '/usuarios': 'Utilizadores',
  '/cidades': 'Cidades',
  '/secretarias': 'Secretarias',
  '/configuracoes': 'Configurações',
}

const restritoAdmin = ['/usuarios', '/cidades', '/secretarias', '/sublocais', '/configuracoes']

function DashboardLayout() {
  const { user, isAuthenticated, isLoading } = useAppAuth()
  const [collapsed, setCollapsed] = useState(false)
  const [menuMovel, setMenuMovel] = useState(false)
  const location = useLocation()

  // Fecha a gaveta ao navegar
  useEffect(() => {
    setMenuMovel(false)
  }, [location.pathname])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA]">
        <div className="w-6 h-6 border-2 border-[#1E4FBF] border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!isAuthenticated)
    return <Navigate to="/" replace />

  if (user?.role !== 'ADMIN' && restritoAdmin.includes(location.pathname))
    return <Navigate to="/dashboard" replace />

  if (location.pathname === '/protocolos/excluidos' && (user?.role === 'GESTOR' || user?.role === 'COORDENADOR'))
    return <Navigate to="/protocolos" replace />

  const title = titles[location.pathname] || 'PROTOCOLEAI'

  return (
    <div className="flex bg-[#F7F8FA] min-h-screen">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(v => !v)}
        mobileOpen={menuMovel}
        onCloseMobile={() => setMenuMovel(false)}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar title={title} onAbrirMenu={() => setMenuMovel(true)} />
        <main className="flex-1 p-3.5 sm:p-5 lg:p-6 pb-24 lg:pb-6">
          <Outlet />
        </main>
      </div>
      <BottomNav onAbrirMenu={() => setMenuMovel(true)} />
    </div>
  )
}

export default DashboardLayout
